var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61529 6.78196L15.3935 0.0652159L15.5357 -0.1H15.3177H13.9366H13.8907L13.8608 -0.0652165L8.88479 5.7189L4.91637 -0.0566311L4.88657 -0.1H4.83395H0.17202H-0.0180234L0.0896011 0.0566316L6.15823 8.88863L0.0962138 15.9348L-0.0459285 16.1H0.17202H1.55322H1.5991L1.62902 16.0652L6.88856 9.95148L11.0836 16.0566L11.1134 16.1H11.1661H15.828H16.018L15.9104 15.9434L9.61529 6.78196ZM11.8679 14.9075L7.69771 8.94269V8.94235L7.67966 8.91654L7.06037 8.03075L2.2428 1.13974H4.12021L8.06693 6.78525L8.06693 6.78525L8.68623 7.67104L13.7453 14.9075H11.8679Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.efb17ccd78c10079d03fc340d4d8b120.svg";
export { ForwardRef as ReactComponent };